module.exports = __webpack_public_path__ + "img/news9-0.f1ce155f.png";